import React, { useEffect, useRef, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { GatsbyImage } from 'gatsby-plugin-image';

const Card = ({ imgData, title, label }) => (
  <li className="anim-cards__item justify-center">
    <div className="card-v2 rounded">
      <figure>
        <GatsbyImage image={imgData} alt={title} />
        {/* <figcaption className="card-v2__caption px-3 lg:px-5 pt-5 lg:pt-8 pb-3 lg:pb-5">
          <div className="text-lg lg:text-xl">{title}</div>
          <div className="mt-1 lg:mt-1.5 text-sm lg:text-base opacity-70">{label}</div>
        </figcaption> */}
      </figure>
    </div>
  </li>
);

const AnimCards = ({ data, reverse = false, paused, delta = 0.5 }) => {
  const listRef = useRef(null);
  const [translate, setTranslate] = useState(0);
  const animationId = useRef(null);
  const { ref, inView } = useInView({ threshold: 0.1 });

  const animate = () => {
    if (paused) {
      cancelAnimationFrame(animationId.current);
      return;
    }

    const cardWidth = getCardWidth();
    const totalWidth = cardWidth * data.length;
    const newTranslate = reverse ? translate - delta : translate + delta;

    if (Math.abs(newTranslate) >= totalWidth) {
      setTranslate(0);
    } else {
      setTranslate(newTranslate);
    }

    listRef.current.style.transform = `translateX(${-translate}px)`;

    animationId.current = requestAnimationFrame(animate);
  };

  useEffect(() => {
    if (inView && !paused) {
      animationId.current = requestAnimationFrame(animate);
    } else {
      cancelAnimationFrame(animationId.current);
    }
    return () => cancelAnimationFrame(animationId.current);
  }, [inView, paused, translate]);

  const getCardWidth = () => {
    const card = listRef.current.children[0];
    return card.offsetWidth + parseFloat(window.getComputedStyle(card).marginRight);
  };

  const duplicatedData = [...data, ...data, ...data];

  return (
    <div className={`anim-cards js-anim-cards ${reverse ? 'anim-cards--reverse' : ''}`} ref={ref}>
      <ul className="anim-cards__list gap-5" ref={listRef}>
        {duplicatedData.map((item, index) => (
          <Card key={index} imgData={item.imgData} title={item.title} label={item.label} />
        ))}
      </ul>
    </div>
  );
};

const AnimCardsContainer = ({ data, title, delta = 0.5 }) => {
  const [paused, setPaused] = useState(false);

  const handlePausePlay = () => {
    setPaused(!paused);
  };

  return (
    <>
      <div className="container mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 justify-between items-center gap-3 mb-10">
            <h2 className="text-center lg:text-start mb-0">{title}</h2>
            <div className="text-center lg:text-end">
                <span className="me-2">Play / Pause slide</span>
                <button
                  className="anim-cards-control js-anim-cards-control js-tab-focus"
                  aria-label={paused ? 'play animation' : 'pause animation'}
                  aria-pressed={paused}
                  onClick={handlePausePlay}
                >
                  <i className="not-italic"></i>
                </button>
            </div>
        </div>
      </div>

      <div id="animated-cards">
        <AnimCards data={data} reverse={false} paused={paused} delta={delta} />
      </div>
    </>
  );
};

export default AnimCardsContainer;
